import { useCallback } from 'react';
import { useUpdateMutation } from '../../graphql';
import { useEnsureUnlocked } from '../../offline/useEnsureUnlocked';

export const useUpdateWorkspaceAsset = () => {
  const mutation = useUpdateMutation({
    modelName: 'workspaceAsset',
    query: UPDATE_WORKSPACE_ASSET,
  });
  const ensureUnlocked = useEnsureUnlocked();
  const { mutateAsync } = mutation;
  // Group reassignment: refuses first while a queued submission still touches
  // the workspace asset (or the asset behind it).
  const guardedMutateAsync = useCallback(
    async (...args: Parameters<typeof mutateAsync>) => {
      const [variables] = args;
      await ensureUnlocked(variables?.input?.id);
      return mutateAsync(...args);
    },
    [ensureUnlocked, mutateAsync]
  ) as typeof mutateAsync;
  return { ...mutation, mutateAsync: guardedMutateAsync };
};

const UPDATE_WORKSPACE_ASSET = `
  mutation updateWorkspaceAsset($input: MutateWorkspaceAssetInput!) {
    updateWorkspaceAsset(input: $input) {
      id
    }
  }
`;
